export default {
  tickets: 'Tickets',
  permissions: 'Permissões',
  warroom: 'War-Room',
  sac: 'Conversas',
  performance: 'Métricas Proprietárias',
  modules: 'Módulos'
};

